module.exports = __webpack_public_path__ + "img/dj1.003cc9fa.jpg";